export const getCapitalized = (title: string) => {
  if (!title) {
    return "";
  }

  return title.replace(title.charAt(0), title.charAt(0).toUpperCase());
};

export const getTypeDescription = (title: string) => {
  switch (title) {
    case "stress":
      return "Learn which parts of a word to stress in English.";
    case "rhythm":
      return "Find out how to emphasize what's important in your sentences.";
    case "intonation":
      return "Learn how your voice should rise and fall in English.";
    case "linking":
      return "Discover which sounds naturally connect to each other in English.";
    default:
      return "";
  }
};

export const formatCategoryFormat = (name: string) => {
  if (name.includes("Reduced Speech")) {
    const spittedText = name.split("Reduced Speech");
    return `Reduced Speech: ${spittedText[1].trim()}`;
  }

  if (name.includes("Consonant")) {
    const spittedText = name.split("Consonant");
    const trimmed2ndWord = spittedText[1].trim();
    let trim2ndWord="Vowel";
    if (trimmed2ndWord === "y") {
      trim2ndWord = "/y/";
    } else if (trimmed2ndWord === "Same") {
      trim2ndWord = "Same Consonant";
    }
    return `Consonant + ${trim2ndWord}`;
  }

  if (name === "VowelVowel") {
    return `Vowel + Vowel`;
  }

  return name;
};


